import { Modal, Button } from 'react-bootstrap'
import React, { useState } from 'react'
import './ReportComment.scss'
import AloModal from '../AloModal'
import commentAxios from 'api/commentsAxios'

const ReportComment = ({
  reply,
  commentId,
  id,
  show,
  closeHandler,
  type,
  setReportComt,
  setShowSnackbar
}) => {
  const [reportStatus, setReportStatus] = useState(true)
  const [load, setLoad] = useState(false)

  const reportComment = async () => {
    if (load) return
    setReportStatus(false)
    try {
      setLoad(true)
      const response = await commentAxios.post('/report', {
        content_id: id,
        content_type: type,
        comment_id: commentId,
        reply_id: reply?.replyId
      })
      if (response.status === 200) {
        setReportStatus(true)
        closeHandler()
        setReportComt(true)
        setShowSnackbar(true)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setLoad(false)
    }
  }
  return (
    <AloModal
      className='playlist-modal modal-confirm'
      backdrop='static'
      show={show}
      onHide={closeHandler}
    >
      <Modal.Header className='report-comment-header'>
        REPORT COMMENT
      </Modal.Header>
      <Modal.Body className='report-comment-body'>
        Are you sure you want to report this comment?
      </Modal.Body>
      <Modal.Footer className='report-comment-footer'>
        <Button className='report-comment-cancel' onClick={closeHandler}>
          Cancel
        </Button>
        <Button className='report-comment-report' onClick={reportComment}>
          {reportStatus ? 'Report' : 'Reporting'}
        </Button>
      </Modal.Footer>
    </AloModal>
  )
}

export default ReportComment
